
import { commonfunc } from '~/mixin/common'

export default {
  name: 'ProdName',
  mixins: [commonfunc],
  props: {
    bestYn: {
      type: Boolean,
      default: false
    },
    exhPdNm: {
      type: String,
      default: ''
    },
    isBoxPd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    preFix () {
      return this.isBoxPd
        ? '박스배송'
        : this.bestYn
          ? 'BEST'
          : ''
    }
  }
}
